exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".numeric-summary[data-v-1572f29f]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.numeric-summary>div[data-v-1572f29f]{-webkit-box-flex:0;-ms-flex:0 0 50%;flex:0 0 50%}.status-wrapper[data-v-1572f29f]{margin:0 0 .5rem}.secondary[data-v-1572f29f]{font-size:12px;font-style:italic;white-space:pre-line;word-break:break-word}.print-version[data-v-1572f29f]{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1572f29f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/EstimateViewer.vue
// module id = 483
// module chunks = 0